import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import { jsBridgeForSSAI } from './utils';
var DataGovernance = function () {
    function DataGovernance(options) {
        _classCallCheck(this, DataGovernance);
        this.action = 'reportCount';
        this.ext = options;
        this.packageMapping = {
            'ssai.h5.study.coursestudy': [
                '/meta',
                '/normalized',
                '/primaryen'
            ],
            'ssai.h5.study.wrongbook': ['/wrongbook']
        };
        this.interval = 60;
        this.uri = '';
        this.metaUri = '/meta';
        this.normalizedUri = '/normalized';
        this.primaryEnUri = '/primaryen';
        this.wrongbookUri = '/wrongbook';
        this.allowUris = [
            this.metaUri,
            this.normalizedUri,
            this.primaryEnUri,
            this.wrongbookUri
        ];
        this.packageId = this.getPackage();
        window.unSupportProtocol = function () {
            console.warn('学习版本不支持数据治理协议\uFF01');
            window.dataGovernanceTimer && clearInterval(window.dataGovernanceTimer);
        };
    }
    _createClass(DataGovernance, [
        {
            key: 'sendData',
            value: function sendData() {
                var _this = this;
                if (this.allowUris.indexOf(this.uri) !== -1) {
                    var param = this.packData();
                    if (param.extra && param.extra.account_id) {
                        param.extra = JSON.stringify(param.extra);
                        window.dataGovernanceTimer = setInterval(function () {
                            console.log(param, '发送的数据治理');
                            jsBridgeForSSAI(_this.action, param, '', 'unSupportProtocol');
                        }, this.interval * 1000);
                    } else {
                        console.log(param, '数据治理为空');
                    }
                } else {
                    console.log('不支持数据治理');
                }
            }
        },
        {
            key: 'getExtData',
            value: function getExtData() {
                var extData = null;
                switch (this.uri) {
                case this.metaUri:
                    extData = this.getMetaExtData();
                    break;
                case this.primaryEnUri:
                    extData = this.getPrimaryEnExtData();
                    break;
                case this.normalizedUri:
                    extData = this.getNormalizedExtData();
                    break;
                case this.wrongbookUri:
                    extData = this.getWrongbookExtData();
                    break;
                default:
                    break;
                }
                return extData;
            }
        },
        {
            key: 'getMetaExtData',
            value: function getMetaExtData() {
                var userInfo = localStorage.getItem('UserInfo');
                debugger;
                if (userInfo) {
                    userInfo = JSON.parse(userInfo);
                    return {
                        account_id: userInfo.accountId,
                        subject_id: userInfo.subjectId,
                        course_id: userInfo.courseId,
                        course_name: userInfo.courseName,
                        learn_type: userInfo.subjectId
                    };
                }
                return null;
            }
        },
        {
            key: 'getPrimaryEnExtData',
            value: function getPrimaryEnExtData() {
                var lms_user_info = localStorage.getItem('lms_user_info');
                var userInfo = lms_user_info ? JSON.parse(lms_user_info) : '';
                if (userInfo) {
                    return {
                        account_id: userInfo.accountId,
                        subject_id: 1,
                        course_id: userInfo.courseId,
                        course_name: userInfo.courseName,
                        learn_type: userInfo.type || 0
                    };
                }
                return null;
            }
        },
        {
            key: 'getNormalizedExtData',
            value: function getNormalizedExtData() {
                var lms_user_info = localStorage.getItem('lms_user_info');
                var userInfo = lms_user_info ? JSON.parse(lms_user_info) : '';
                if (userInfo) {
                    return {
                        account_id: userInfo.account_id,
                        subject_id: userInfo.subject_id,
                        course_id: userInfo.course_id,
                        course_name: userInfo.course_name,
                        learn_type: userInfo.type || 0
                    };
                }
                return null;
            }
        },
        {
            key: 'getWrongBookExtData',
            value: function getWrongBookExtData() {
                var sessionStorage = sessionStorage.getItem('');
                return {};
            }
        },
        {
            key: 'packData',
            value: function packData() {
                return {
                    app_pkg: this.packageId,
                    app_name: '课程学习',
                    timestamp: parseInt(+new Date() / 1000),
                    extra: this.getExtData(),
                    type: '学习类',
                    duration: this.interval
                };
            }
        },
        {
            key: 'getPackage',
            value: function getPackage() {
                var _this2 = this;
                var path = location.pathname.split('/');
                var url = path[1];
                this.uri = '/' + url;
                var mappingObj = {};
                var _loop = function _loop(key) {
                    _this2.packageMapping[key].forEach(function (item) {
                        mappingObj[item] = key;
                    });
                };
                for (var key in this.packageMapping) {
                    _loop(key);
                }
                console.log(mappingObj[this.uri], '包名');
                if (mappingObj[this.uri]) {
                    return mappingObj[this.uri];
                }
                return null;
            }
        }
    ]);
    return DataGovernance;
}();
export default DataGovernance;